import {
  Mapping,
  MappingIdentifierType,
} from 'src/containers/ProjectDiagram/types/data';
import {
  isMapping,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link Project} remove relationship mappings that use undefined fields
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v39 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v39Projects(prevState.projects);
  }

  return nextState;
};

const v39Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const mappingsByKey = project.diagram.model.linkDataArray.reduce<
      Record<string, Mapping>
    >((acc, linkData) => {
      if (isMapping(linkData)) {
        acc[linkData.key] = linkData;
      }
      return acc;
    }, {});

    const linkDataArray = project.diagram.model.linkDataArray.filter(
      (linkData) => {
        if (isRelationshipMapping(linkData)) {
          if (
            linkData.toPrimaryIdentifier?.parts.some(
              (part) =>
                part.type === MappingIdentifierType.FIELD &&
                !mappingsByKey[linkData.from]?.fields[part.value]
            )
          ) {
            return false;
          }

          if (
            linkData.fromPrimaryIdentifier?.parts.some(
              (part) =>
                part.type === MappingIdentifierType.FIELD &&
                !mappingsByKey[linkData.to]?.fields[part.value]
            )
          ) {
            return false;
          }
        }

        return true;
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          linkDataArray,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
